var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { MatDialog, MatSnackBar } from '@angular/material';
import { SplashDialogComponent, _SplashOptions } from './splash.component';
export { _SplashOptions as SplashOptions };
var SplashService = /** @class */ (function () {
    function SplashService(dialog, snackbar) {
        this.dialog = dialog;
        this.snackbar = snackbar;
    }
    SplashService.prototype.DisplaySplash = function (options) {
        this.openHandle = this.dialog.open(SplashDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Please wait', MessageText: 'Loading...', ShowProgressBar: true }, options),
        });
        return this.openHandle.afterOpen();
    };
    SplashService.prototype.CloseSplash = function () {
        if (this.openHandle) {
            this.openHandle.close();
            this.openHandle = null;
        }
    };
    SplashService.prototype.SnackbarAlert = function (message, duration) {
        var config = {
            extraClasses: ['alert'],
        };
        config.duration = duration != null ? duration : 3500;
        return this.snackbar.open(message, null, config);
    };
    SplashService.prototype.SnackbarSuccess = function (message, duration) {
        var config = {
            extraClasses: ['success'],
        };
        config.duration = duration || 3500;
        return this.snackbar.open(message, null, config);
    };
    SplashService.prototype.SnackbarError = function (message, duration, hold) {
        var config = {
            extraClasses: ['error'],
        };
        var action = null;
        if (duration != null) {
            config.duration = duration;
        }
        if (hold === true) {
            action = 'OK';
            config.duration = 5 * 60 * 1000; // 5 minutes?
        }
        return this.snackbar.open(message, action, config);
    };
    return SplashService;
}());
export { SplashService };



// WEBPACK FOOTER //
// ./src/services/splash/splash.service.ts.pre-build-optimizer.js